import { render, staticRenderFns } from "./CarouselBuilder.vue?vue&type=template&id=61f05fe3&scoped=true"
import script from "./CarouselBuilder.vue?vue&type=script&lang=js"
export * from "./CarouselBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f05fe3",
  null
  
)

export default component.exports